import { Tile } from "types/Tile";
import { Dietanamnez } from "types/Dietanamnez";
import { UserType } from "types/UserType";

function getVisibleItems(items: Tile[], dietanamnez: Dietanamnez, userType: UserType) {
  const specificMap = dietanamnez.custom_специфические_виды_питания.reduce((acc, item) => ({
    ...acc,
    [item]: true,
  }), {} as { [key: string]: boolean });

  return items
    .filter(({ custom_формат }) => !custom_формат || custom_формат.value === dietanamnez.custom_тип_да)
    .filter(({ custom_версия_приложения: { value } = {} }) => !value || value === userType)
    .filter((item) => {
      const { custom_специфические_исключения } = item;

      if (!custom_специфические_исключения) {
        return true;
      }

      return custom_специфические_исключения.every(item => !specificMap[item.key]);
    })
}

function getTilesGroups(items: Tile[], dietanamnez: Dietanamnez, userType: UserType) {
  return getVisibleItems(items, dietanamnez, userType)
    .filter(({ ___parent: parent }) => !parent)
    .map(item => item.key);
}

export function getVisibleTiles(tiles: Tile[], dietanamnez: Dietanamnez, userType: UserType) {
  const groups = getTilesGroups(tiles, dietanamnez, userType);
  const items = getVisibleItems(tiles, dietanamnez, userType)
    .filter(({ ___parent: parent }) => !!parent)

  return groups.map(groupKey => items.filter(item => item.___parent.key === groupKey)).reduce((acc, item) => {
    acc.push(...item);
    return acc;
  }, [] as Tile[])
}